import {
  Media,
  MediaQuestionConfig,
  MediaResponseState,
  MediaType,
  useFindMedia,
  useGrippContext,
} from '@gripp/shared-logic';
import { useFieldArray, useWatch } from 'react-hook-form';
import { useFormContext } from '../../../../forms';
import { HorizontalMediaGallery } from '../../../../media';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

export const MediaQuestionExecutionForm: RoutineQuestionExecutionForm<
  MediaQuestionConfig,
  MediaResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    MediaQuestionConfig,
    MediaResponseState
  >
) => {
  const { mediaPickerComponent: MediaPicker } = useGrippContext();
  const fieldName = `responses.${props.responseIndex}.mediaIds`;
  const { control } = useFormContext();
  control.register(fieldName, { value: [] });
  const { append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const mediaIds: string[] = useWatch({ control, name: fieldName }) ?? [];

  const existingMedia = useFindMedia({
    filter: { id: { in: mediaIds.length > 0 ? mediaIds : undefined } },
  });

  const onMediaAdded = (mediaItem: Media) => {
    append(mediaItem.id);
  };

  const onMediaDeleted = (mediaId: string) => {
    const index = mediaIds.indexOf(mediaId);
    if (index >= 0) remove(index);
  };

  return (
    <HorizontalMediaGallery
      media={existingMedia}
      onMediaAdded={onMediaAdded}
      mediaPicker={MediaPicker}
      acceptedMediaTypes={[MediaType.Image]}
      onMediaDeleted={onMediaDeleted}
      canEditMedia={true}
      onUploadingChanged={props.toggleProcessing}
      workspaceId={props.workspaceAsset.workspace.id}
    />
  );
};
